import { LoadingOutlined } from '@ant-design/icons';
import { Alert, Button, Modal, Spin } from 'antd';

import { useGetHotel } from 'app/hooks/data/hotels/useHotel';
import { ChannelManager } from 'app/typings/channelManagers';

import './MergeLoadingModal.scss';

type MergeLoadingModalProps = {
  isOpen: boolean;
  hotelId: string;
  mergeHaveTimeout: boolean;
  hasCreateNewRoom: boolean;
};

export const MergeLoadingModal = ({
  isOpen,
  hotelId,
  mergeHaveTimeout,
  hasCreateNewRoom,
}: MergeLoadingModalProps) => {
  const { data: hotel } = useGetHotel(Number(hotelId));

  const hotelHasChannelManager =
    !!hotel?.channelManager && hotel.channelManager !== ChannelManager.NONE;

  return (
    <Modal
      open={isOpen}
      footer={null}
      closable={false}
      centered
      className="merge-loading-modal"
      width={416}
    >
      <div className="merge-loading-modal__content">
        {mergeHaveTimeout ? (
          <>
            <div className="merge-loading-modal__content__texts">
              <div className="title">It takes longer than usual ...</div>
              <div className="description">
                We'll send you a Slack notification when the merge is done for
                this hotel.
              </div>
            </div>
            <div className="button">
              <Button
                type="primary"
                onClick={() => window.open(`/hotels`, '_blank')}
              >
                Back to Hotel list
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className="merge-loading-modal__content__header">
              <Spin indicator={<LoadingOutlined spin />} />
            </div>
            <div className="merge-loading-modal__content__texts">
              <div className="title">Merge in progress</div>
              <div className="description">
                It should take less than 15 seconds.
              </div>
            </div>
            {hasCreateNewRoom &&
              (hotelHasChannelManager || hotel?.stockScrapperEnabled) && (
                <Alert
                  showIcon
                  message={
                    hotelHasChannelManager
                      ? 'Channel Manager room addition'
                      : 'Auto-inventory matching needed'
                  }
                  description={
                    hotelHasChannelManager
                      ? 'When the merge is complete, it will be necessary to add a new room in the channel manager.'
                      : 'When the merge is complete, it will be necessary to match the new room created.'
                  }
                  type="info"
                />
              )}
          </>
        )}
      </div>
    </Modal>
  );
};
